/**
 *  Copyright (c) 2026 TechDivision GmbH
 *  All rights reserved
 *
 *  This product includes proprietary software developed at TechDivision GmbH, Germany
 *  For more information see https://www.techdivision.com/
 *
 *  To obtain a valid license for using this software please contact us at
 *  license@techdivision.com
 *
 */

/* pdf-downloads.js
   Multi PDF Download – client-side search (title + description) and grid/list view switch. */

export function initPdfDownloads() {
  var roots = document.querySelectorAll('[data-pdf-downloads]');
  if (!roots.length) return;

  roots.forEach(function (root) {
    var searchInput = root.querySelector('[data-pdf-search]');
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-pdf-item]'));
    var emptyMessage = root.querySelector('[data-pdf-empty]');
    var viewButtons = Array.prototype.slice.call(root.querySelectorAll('[data-pdf-view-btn]'));

    // grid/list view switch
    function setView(view) {
      root.setAttribute('data-view', view);
      viewButtons.forEach(function (btn) {
        btn.setAttribute('aria-pressed', btn.getAttribute('data-pdf-view-btn') === view ? 'true' : 'false');
      });
    }

    viewButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setView(btn.getAttribute('data-pdf-view-btn'));
      });
    });

    // client-side search over title + description (data-search-text)
    function filter(query) {
      var term = query.trim().toLowerCase();
      var visible = 0;

      items.forEach(function (item) {
        var haystack = item.getAttribute('data-search-text') || '';
        var match = term === '' || haystack.indexOf(term) !== -1;
        item.hidden = !match;
        if (match) visible++;
      });

      if (emptyMessage) emptyMessage.hidden = visible !== 0;
    }

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        filter(searchInput.value);
      });
    }
  });
}

// loaded as a module script by the section that needs it (see
// snippets/module-script.liquid), so the module initialises itself. module
// scripts are deferred, which means the DOM is complete at this point
initPdfDownloads();
